import ApiClient from "../helpers/ApiClient";

const getLogos = () =>
  ApiClient.backendClient.get(`api/logos/Logos`, {
    headers: {
      Token: process.env.REACT_APP_TOKEN,
    },
  });

const postLogos = (data) =>
  ApiClient.backendClient.post(`api/logos/Logos`, data, {
    headers: {
      Token: process.env.REACT_APP_TOKEN,
    },
  });

const deleteLogos = (nome, extensao) =>
  ApiClient.backendClient.delete(`api/logos/Logos/${nome}/${extensao}`, {
    headers: {
      Token: process.env.REACT_APP_TOKEN,
    },
  });

const LogosApiClient = { getLogos, postLogos, deleteLogos };
export default LogosApiClient;
